import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import { ShareIcon } from '../../images/icons/share';
import Bag from '../../images/illustrations/rounded-bag.webp';
import Bag2x from '../../images/illustrations/rounded-bag-2x.webp';
import Bag3x from '../../images/illustrations/rounded-bag-3x.webp';
import Button from '../Forms/Button';
import { Icon18 } from '../Icon';
import messages from './messages';

const Container = styled.div`
  ${tw`md:p-big mt-big flex flex-col items-center sm:flex-row `}
  gap: var(--size-medium)
`;

const ContentWrapper = styled.div`
  ${tw`md:px-medium`}
`;

const TextWrapper = styled.div`
  ${tw`flex flex-col`}
  gap:var(--size-small)
`;

const Text = styled.span`
  ${tw`text-p-small leading-p-small`}
`;

const ActionsWrapper = styled.div`
  ${tw`mt-medium flex flex-wrap`}
  gap: var(--size-medium)
`;

type BoxActionsProps = {
  title: ReactNode;
  content: ReactNode;
  shareData?: ShareData;
};

const BoxActions = (props: BoxActionsProps) => {
  const { content, shareData, title } = props;

  if (!navigator.share) {
    return null;
  }

  return (
    <Container>
      <div>
        <img
          alt="Illustration"
          height={150}
          src={Bag}
          srcSet={`${Bag2x} 2x, ${Bag3x} 3x`}
          width={150}
        />
      </div>

      <ContentWrapper>
        <TextWrapper>
          <Text style={{ fontWeight: 'bold' }}>{title}</Text>

          <Text>{content}</Text>
        </TextWrapper>

        <ActionsWrapper>
          <Button
            onClick={() => {
              navigator.share({
                url: window.location.href,
                ...shareData,
              });
            }}
            rightIcon={
              <ShareIcon
                customStyle={css`
                  ${Icon18}
                `}
              />
            }
            size="MEDIUM"
            variant="PRIMARY"
          >
            <FormattedMessage {...messages.share} />
          </Button>
        </ActionsWrapper>
      </ContentWrapper>
    </Container>
  );
};

export default BoxActions;
